export default __webpack_public_path__ + "static/media/Q3_4.2f4e0f01.jpg";